export var INTERPOLATION_TYPE = {
  LINEAR: 0,
  CATMULLROM: 1,
  CATMULLROM_FORWARD: 2 };